import * as React from 'react';
import { makeStyles } from '@material-ui/styles';
import { CardHeader, Theme, Card, CardContent, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import TabContainer from 'pages/Report/components/TabContainer';
import FoodWasteDistribution from 'pages/Report/components/FoodWasteDistribution';
import Trend from './components/Trend';
import { Basis } from 'redux/ducks/reportFilter';

interface OwnProps {
  onTabChange: (basis) => void;
  basis: Basis;
}

type ComponentProps = OwnProps;

const FoodWasteOverview: React.FunctionComponent<ComponentProps> = (props) => {
  const classes = useStyles(props);
  const intl = useIntl();
  const { onTabChange, basis } = props;

  return (
    <Card>
      <CardHeader title={intl.formatMessage({ id: 'report.overview' })} />
      <CardContent>
        <TabContainer onTabChange={onTabChange} initialValue={basis}>
          <div className={classes.tabContent}>
            <Typography variant={'body1'} paragraph={true}>
              {basis === 'per-guest'
                ? intl.formatMessage({ id: 'report.quickOverview.foodwastePerGuest.description' })
                : intl.formatMessage({ id: 'report.quickOverview.totalFoodwaste.description' })}
            </Typography>
            <FoodWasteDistribution />
            <Trend />
          </div>
        </TabContainer>
      </CardContent>
    </Card>
  );
};

const useStyles = makeStyles<Theme, ComponentProps>((theme) => ({
  tabContent: {
    margin: theme.spacing(3, 0, 0)
  }
}));

export default FoodWasteOverview;
